module.exports = __webpack_public_path__ + "static/media/GIFT_WITH_PURCHASE_60X50.f58ea98d.svg";